export default "__VITE_ASSET__ZjgEwIzr__"